import { render, staticRenderFns } from "./WhUpload.vue?vue&type=template&id=1adc80d8&scoped=true&"
import script from "./WhUpload.vue?vue&type=script&lang=js&"
export * from "./WhUpload.vue?vue&type=script&lang=js&"
import style0 from "./WhUpload.vue?vue&type=style&index=0&id=1adc80d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adc80d8",
  null
  
)

export default component.exports